module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "max-width": "500px",
      "persistent": ""
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "title"
  }, [_vm._v("Update Status")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "mt-3 body-2"
  }, [_c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var hover = ref.hover;

        return [_c('v-card', {
          class: {
            'mx-auto mb-5 text-center on-hover': hover,
            'mx-auto mb-5 text-center': !hover
          },
          staticStyle: {
            "width": "300px"
          },
          attrs: {
            "color": "#363636",
            "dark": "",
            "elevation": hover ? 12 : 2
          }
        }, [_c('v-card-subtitle', [_c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Total Influencers: " + _vm._s(_vm.payments.length))]), _vm._v(" "), _vm._l((_vm.currencyTotals), function(item, index) {
          return _c('span', {
            key: index
          }, [(item) ? _c('p', {
            staticClass: "pa-0 ma-0 custom-font"
          }, [_vm._v("Total "), (index === 'SGD') ? _c('span', [_vm._v("Amount in ")]) : _vm._e(), _vm._v(" " + _vm._s(index) + ": " + _vm._s(_vm.utilsFunc.currencySym(index)) + " " + _vm._s(_vm._f("thousandSeprator")(item)))]) : _vm._e()])
        })], 2)], 1)]
      }
    }])
  }), _vm._v(" "), _c('v-form', {
    ref: "paymentForm",
    attrs: {
      "lazy-validation": ""
    },
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [(_vm.showField('PVNumber')) ? _c('v-text-field', {
    attrs: {
      "dense": "",
      "outlined": "",
      "label": "PV Number",
      "required": "",
      "rules": _vm.MessageRules
    },
    model: {
      value: (_vm.data.PVNumber),
      callback: function($$v) {
        _vm.$set(_vm.data, "PVNumber", $$v)
      },
      expression: "data.PVNumber"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showField('bankReference')) ? _c('v-text-field', {
    attrs: {
      "dense": "",
      "outlined": "",
      "label": "Bank Reference",
      "required": "",
      "rules": _vm.MessageRules
    },
    model: {
      value: (_vm.data.bank_reference),
      callback: function($$v) {
        _vm.$set(_vm.data, "bank_reference", $$v)
      },
      expression: "data.bank_reference"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showField('paymentDate')) ? _c('v-text-field', _vm._g({
    attrs: {
      "dense": "",
      "outlined": "",
      "label": "Payment Date (DD/MM/YYYY)",
      "required": "",
      "rules": _vm.MessageRules
    },
    model: {
      value: (_vm.data.payment_date),
      callback: function($$v) {
        _vm.$set(_vm.data, "payment_date", $$v)
      },
      expression: "data.payment_date"
    }
  }, _vm.on)) : _vm._e(), _vm._v(" "), (_vm.showField('submissionDate')) ? _c('v-text-field', _vm._g({
    attrs: {
      "dense": "",
      "outlined": "",
      "label": "Submission Date (DD/MM/YYYY)",
      "required": "",
      "rules": _vm.MessageRules
    },
    model: {
      value: (_vm.data.payment_submission_date),
      callback: function($$v) {
        _vm.$set(_vm.data, "payment_submission_date", $$v)
      },
      expression: "data.payment_submission_date"
    }
  }, _vm.on)) : _vm._e(), _vm._v(" "), (_vm.showField('batch')) ? _c('v-select', {
    attrs: {
      "items": _vm.batches,
      "label": "Select Batch",
      "dense": "",
      "outlined": "",
      "required": "",
      "rules": _vm.MessageRules
    },
    model: {
      value: (_vm.data.batch),
      callback: function($$v) {
        _vm.$set(_vm.data, "batch", $$v)
      },
      expression: "data.batch"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showField('paymentStatus')) ? _c('v-select', {
    attrs: {
      "items": _vm.showStatuses,
      "item-value": "status",
      "item-text": "display",
      "label": "Payment Status",
      "dense": "",
      "outlined": "",
      "required": "",
      "rules": _vm.MessageRules
    },
    on: {
      "change": function($event) {
        return _vm.changeStatus()
      }
    },
    model: {
      value: (_vm.data.payment_status),
      callback: function($$v) {
        _vm.$set(_vm.data, "payment_status", $$v)
      },
      expression: "data.payment_status"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.showField('actualAmount')) ? _c('v-simple-table', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function() {
        return [_c('thead', [_c('tr', [_c('th', {
          staticClass: "text-left"
        }, [_vm._v("Handle")]), _vm._v(" "), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("Amount")]), _vm._v(" "), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("Actual Amount")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.payments), function(item) {
          return _c('tr', {
            key: item.title
          }, [_c('td', [_c('div', [_vm._v(_vm._s(item.instagram))])]), _vm._v(" "), _c('td', [_c('div', [_vm._v(_vm._s(_vm.utilsFunc.currencySym(item.currency)) + " " + _vm._s(item.amount))])]), _vm._v(" "), _c('td', [(item.currency !== 'SGD') ? _c('v-text-field', {
            attrs: {
              "label": "Amount",
              "type": "number",
              "placeholder": "",
              "outlined": "",
              "dense": "",
              "hide-details": "auto"
            },
            model: {
              value: (item.actualAmount),
              callback: function($$v) {
                _vm.$set(item, "actualAmount", $$v)
              },
              expression: "item.actualAmount"
            }
          }) : _vm._e()], 1)])
        }), 0)]
      },
      proxy: true
    }], null, false, 2559575621)
  }) : _vm._e()], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "red",
      "id": "close",
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Save")])], 1)], 1), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "180",
      "height.number": "180"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b5c851a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Finance/UpdatePaymentInfoModal.vue
// module id = 2055
// module chunks = 0